// Func = limiting Scope for this file
(function(){
	$('.header__menu-btn').click(function(){
		$('body').addClass('pause-scroll');
		$('.header__nav, .privary-navigation').addClass('menu-open');
	});
	$('.secondary-primary-nav nav#primary-nav').attr('id','primary-nav-2');
	$('.secondary-primary-nav ul#privary-navigation').attr('id','privary-navigation-2');

	$('.header__close-btn').click(function(){
		$('body').removeClass('pause-scroll');
		$('.header__nav, .privary-navigation').removeClass('menu-open');
	});

	$(document).ready(function () {
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$('.header__booking-trigger, .header__booking-close').click(function(){
			$('.header__booking-content, .booking-widget').toggleClass('active');
			$('body').toggleClass('booking-open');
		});

		// Booking Calendar
		let bookingDateFormat = 'mm/dd/yy';
		let start, end, op = 0;

		const calendarBeforeShow = date => {
			if ( start !== undefined ){
				let startDate = $.datepicker.parseDate(bookingDateFormat, start);
				let endDate = $.datepicker.parseDate(bookingDateFormat, end);
				if ( date.getTime() == startDate.getTime() ) {
					return[ true, 'startday' ];
				} else {
					if ( date.getTime() == endDate.getTime() ) {
						return[ true, 'endday' ];
					} else {
						if( date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime() ){
							return[ true, 'days' ];
						} else {
							return[ true ];
						}
					}
				}
			} else{
				return[ true ];
			}
		};

		const calendarOnSelect = date => {
			start = (start !== undefined) ? start : $.datepicker.formatDate(bookingDateFormat, new Date());
			let startDate = $.datepicker.parseDate(bookingDateFormat, start);
			let selectedDate = $.datepicker.parseDate(bookingDateFormat, date);
			
			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;  
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;  
				} else {
					end =  date; 
				}
			}

			$('#checkin').attr('value',start);
			$('#checkout').attr('value',end);
		};

		const calendarOptions = {
			minDate: 0,
			numberOfMonths: 2,
			dateFormat: bookingDateFormat,
			beforeShowDay: calendarBeforeShow,
			onSelect: calendarOnSelect
		};

		$('#dateCalendar').datepicker( calendarOptions );

		

		
	});

}());